import React from 'react'
import { ReactComponent as AtlasIconSvg } from '../../assets/images/atlas-logo.svg'
import SvgIcon from '@mui/material/SvgIcon'

type AtlasIconProps = {
    fontSize?: string
    color?: string
}

const AtlasIcon = ({ fontSize = '32px', color = 'figma.grayscale.tier1' }: AtlasIconProps) => {
    return <SvgIcon component={AtlasIconSvg} inheritViewBox sx={{ fontSize, color, width: 'auto' }} />
}

export default AtlasIcon
